export var LOCALSTORAGE_USER_SESSION_KEY = '__crehana__user__session';
export var B2B_ORGANIZATION_ASSIGNED_TYPES = {
  ALL_CATALOG: 1,
  ONLY_PANEL: 2
};